import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import FloridaLogo from './FloridaLogo';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Concrete Cutting',
    'Core Drilling',
    'Demolition',
    'Wall Sawing',
    'Flat Sawing',
  ];

  const serviceAreas = [
    'Miami, FL',
    'Broward County',
    'Florida Keys',
  ];

  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 text-white relative overflow-hidden"
    >
      {/* Background Text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="font-heading text-[20rem] font-bold text-slate-800/20 tracking-tighter uppercase select-none hidden lg:block">
          FLORIDA
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <FloridaLogo className="h-12 w-auto" />
              <div>
                <span className="font-heading text-xl font-bold tracking-tight uppercase block">
                  Florida
                </span>
                <span className="font-heading text-sm font-semibold text-orange-500 tracking-widest uppercase">
                  Concrete Cutting
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Professional concrete cutting, core drilling, and demolition services 
              throughout Florida. Licensed, insured, and committed to excellence.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+17863047898"
                className="flex items-center gap-3 text-slate-300 hover:text-orange-500 transition-colors"
              >
                <Phone className="h-4 w-4" />
                (786) 304-7898
              </a>
              <a
                href="mailto:flconcretesales@gmail.com"
                className="flex items-center gap-3 text-slate-300 hover:text-orange-500 transition-colors"
              >
                <Mail className="h-4 w-4" />
                flconcretesales@gmail.com
              </a>
              <div className="flex items-center gap-3 text-slate-300">
                <MapPin className="h-4 w-4" />
                Across South Florida
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wider mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-slate-400 hover:text-orange-500 transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wider mb-6">
              Service Areas
            </h4>
            <ul className="space-y-3">
              {serviceAreas.map((area) => (
                <li key={area} className="text-slate-400">
                  {area}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wider mb-6">
              Emergency Service
            </h4>
            <p className="text-slate-400 mb-4">
              Need immediate assistance? We offer 24/7 emergency concrete cutting services.
            </p>
            <a
              href="tel:+17863047898"
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 font-bold uppercase tracking-wider transition-all hover:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)]"
            >
              Call Now
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} Florida Concrete Cutting Services. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-slate-500 hover:text-slate-300 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-slate-300 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
